import { reduxForm } from 'redux-form'
import { PersonCoverageForm } from '../components'

export default reduxForm({
  form: 'PersonCoverage',
})(PersonCoverageForm)
